import React from 'react';
import styled from '@emotion/styled';
import {
  SegmentedView,
  SegmentedViewController,
  SegmentedViewData,
} from '../../../components/SegmentedView/SegmentedView';
import ProfileSettings from './ProfileSettings/ProfileSettings';
// import PasswordSettings from './PasswordSettings/PasswordSettings';
import NotificationSettings from './NotificationSettings/NotificationSettings';
import PrivacySettings from './PrivacySettings/PrivacySettings';

const segmentedControllerConfig = [
  { title: 'Profile Settings' },
  // { title: 'Password Settings' },
  { title: 'Notification Settings' },
  { title: 'Privacy Settings' },
];

const segmentedControllerConfigShortText = [
  { title: 'Profile' },
  // { title: 'Password' },
  { title: 'Notification' },
  { title: 'Privacy' },
];

const SettingsSegment = () => {
  return (
    <Container>
      {' '}
      <SegmentedView>
        <SegmentedViewController
          className="large-screen"
          segmentedViewControllerTitle={segmentedControllerConfig}
        />
        <SegmentedViewController
          className="small-screen"
          segmentedViewControllerTitle={segmentedControllerConfigShortText}
        />
        <SegmentedViewData>
          <div>
            <ProfileSettings />
          </div>
          {/* <div>
            <PasswordSettings />
          </div> */}
          <div>
            <NotificationSettings />
          </div>
          <div>
            <PrivacySettings />
          </div>
        </SegmentedViewData>
      </SegmentedView>
    </Container>
  );
};

export default SettingsSegment;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  width: 100%;
  border-radius: 10px;
  background: white;

  @media (max-width: 480px) {
    padding: 5px;
  }
`;
